module.exports = __webpack_public_path__ + "static/webinar18_slides-962b6ab303b827b6c9aa9e13611fbb7c.pdf";